export default {
	"premiumCalc.hero.placeholder": "Bitte wählen Sie ein Produkt",
	"premiumCalc.hero.cta": "Jetzt Tarif berechnen",
} as const;
